import React from "react";
import {BrowserRouter,Routes,Route} from "react-router-dom";
import 'primereact/resources/themes/lara-light-blue/theme.css'; 
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import PrivateRoute from "./components/PrivateRoute";
import SessionManager from "./components/SessionManager";
import Login from "./components/Login";
import Signup from "./components/Signup";
import AdminDashboard from "./components/admin/AdminDashboard";
import Projects from "./components/admin/Projects";
import EmployeeList from "./components/admin/EmployeeList";
import EmployeeDetails from "./components/admin/EmployeeDetails";
import ProjectDetails from "./components/admin/ProjectDetails";
import Timesheet from "./components/admin/Timesheet";
import DetailsPage from "./components/admin/DetailsPage";
import Performance from "./components/admin/Performance";
import AdminProfile from "./components/admin/AdminProfile";
import AdminAccount from "./components/admin/AdminAccount";
import LeaveStatus from "./components/admin/LeaveStatus";
import AdminLeaves from "./components/admin/AdminLeaves";
import GraphRepresentation from "./components/admin/GraphRepresentation";
import TableRepresentation from "./components/admin/TableRepresentation";
import WeeksTimesheet from "./components/employee/WeeksTimesheet";
import TimesheetTable from "./components/employee/TimesheetTable";
import EHome from "./components/employee/EHome";
import Profile from "./components/employee/Profile";
import EAccount from "./components/employee/EAccount";
import ELeaves from "./components/employee/ELeaves";
import EProject from "./components/employee/EProject";
import DocumentUpload from "./components/admin/DocumentUpload";
import Holidays from "./components/Holidays";
import AdminHolidays from "./components/admin/AdminHolidays";
import LeaveRequest from "./components/employee/LeaveRequets";
import EHolidays from "./components/employee/EHolidays";
import EmployeeRemarks from "./components/admin/EmployeeRemarks";
import TimesheetStatus from "./components/admin/TimesheetStatus";
import EmployeeEdit from "./components/admin/EmployeeEdit";
import Reports from "./components/admin/Reports";
import RemarkFilter from "./components/admin/RemarkFilter";
import EmployeeRecord from "./components/admin/EmployeeRecord";
import MissingDocs from "./components/admin/MissingDocs";
import EditTable from "./components/admin/EditTable";
import EditCompanyProfile from "./components/admin/EditCompanyProfile";
import WFHRequest from "./components/employee/WFHRequest";
import WFHRequests from "./components/admin/WFHRequests";
import LeaveDashboard from "./components/employee/LeaveDashboard";
import LeaveHistory from "./components/employee/LeaveHistory";
import WFHDashboard from "./components/employee/WfhDashboard";
import WFHHistory from "./components/employee/WfhHistory";

function App() {

  return (
    <>
    <SessionManager/>
    <BrowserRouter>
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/employee-list" element={<EmployeeList />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/AdminAccount" element={<AdminAccount />} />
        <Route path="/leaves" element={<LeaveStatus />} />
        <Route path="/employeedetails" element={<EmployeeDetails />} />
        <Route path="/editproject/:projectId" element={<ProjectDetails />} />
        <Route path="/timesheet" element={<Timesheet />} />
        <Route path="/details" element={<DetailsPage />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/AdminProfile" element={<AdminProfile />} />
        <Route path="/weeksTimesheet" element={<WeeksTimesheet />} />
        <Route path="/timesheetTable" element={<TimesheetTable />} />
        <Route path="/home" element={<EHome />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/EAccount" element={<EAccount />} />
        <Route path="/Eleaves" element={<ELeaves />} />
        <Route path="/leave-request" element={<LeaveRequest />} />
        <Route path="/EProject" element={<EProject />} />
        <Route path="/document-upload" element={<DocumentUpload />} />
        <Route path="/EHolidays" element={<EHolidays />} />
        <Route path="/AdminHolidays" element={<AdminHolidays />} />
        <Route path="/holidays" element={<Holidays />} />
        <Route path="/AdminLeaves" element={<AdminLeaves />} />
        <Route path="/graphView" element={<GraphRepresentation/>}></Route>
        <Route path="/tableView" element={<TableRepresentation/>}></Route>
        <Route path="/remarks" element={<EmployeeRemarks />} />
        <Route path="/timesheet-defaulters" element={<TimesheetStatus/>}></Route>
        <Route path="/edit-employee/:userId" element={<EmployeeEdit />} />
        <Route path="/add-employee" element={<EmployeeEdit />} />
        <Route path="/Reports" element={<Reports/>} />
        <Route path="/employee-remark-filter" element={<RemarkFilter/>} />
        <Route path="/employee-records" element={<EmployeeRecord/>} />
        <Route path="/missing-docs" element={<MissingDocs/>}/>
        <Route path="/edit-table" element={<EditTable/>}/>
        <Route path="/admin/edit-profile" element={<EditCompanyProfile/>}/>
        <Route path="/wfh-request" element={<WFHRequest/>}/>
        <Route path="/wfh-requests" element={<WFHRequests/>}/>
        <Route path="/leave" element={<LeaveDashboard />} />
        <Route path="/leave-history" element={<LeaveHistory/>} />
         <Route path="/wfh" element={<WFHDashboard/>} />
          <Route path="/wfh-history" element={<WFHHistory/>} />
      </Route>
    </Routes>
  </BrowserRouter>
    </>
    
  );
}

export default App;
